import Tab, {TabProps} from '@mui/material/Tab';
import Tabs, {TabsProps} from '@mui/material/Tabs';
import TabScrollButton, {TabScrollButtonProps} from '@mui/material/TabScrollButton';

import {styled} from '@mui/material/styles';

export const CTab = styled(Tab)<TabProps>(
  (/* { theme } */) => ({
  }),
);

export const CTabs = styled(Tabs)<TabsProps>(
  (/* { theme } */) => ({
  }),
);

export const CTabScrollButton = styled(TabScrollButton)<TabScrollButtonProps>(
  (/* { theme } */) => ({
  }),
);
